import util from '@utils/util';
export default {
  name: 'globalFilterBar',
  props: {
    title: String,
    filters: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultSelected: Object,
    defaultIteamIndex: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      isOpen: true,
      inter: {},
      country: {}
    };
  },
  methods: {
    initInterCountry: function initInterCountry() {
      // eslint-disable-next-line no-nested-ternary
      this.inter = this.defaultSelected ? this.defaultSelected : this.filters.length > 0 ? this.filters[0] : {};
      if (Array.isArray(this.inter.data)) {
        // eslint-disable-next-line prefer-destructuring
        this.country = this.inter.data[this.defaultIteamIndex] ? this.inter.data[this.defaultIteamIndex] : this.inter.data[0];
      }
    },
    titleClickHandler: function titleClickHandler() {
      this.isOpen = !this.isOpen;
    },
    interClickHandler: function interClickHandler(inter) {
      util.KEWLSensorTrack({
        lmweb_clickText: '探索页大区',
        lmweb_tabName: inter.inter
      });
      this.inter = inter;
    },
    countryClickHandler: function countryClickHandler(country) {
      util.KEWLSensorTrack({
        lmweb_clickText: '探索页国家',
        lmweb_tabName: country.country_name
      });
      this.country = country;
    }
  },
  watch: {
    filters: function filters() {
      this.initInterCountry();
    },
    country: function country() {
      this.$emit('select', this.inter, this.country);
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  created: function created() {
    this.initInterCountry();
  },
  destroyed: function destroyed() {}
};